(function () {
  SUGApp.controller("pricingController", ["$scope", "loginfactory", "$window", "$timeout", "globalService", "sugCacheFactory", "SUGUtilities",
    function ($scope, loginfactory, $window, $timeout, globalService, sugCacheFactory, SUGUtilities) {
      // create an instance of the login service
      $scope.login = loginfactory.getLogin(false, true);
      //Defaults
      $scope.useAnnualPricing = true;
      $scope.section = "premium";
      $scope.variationClass = false;

      $scope.buyNow = {
        free: '/index.cfm?go=w.Create1',
        trial: '/index.cfm?go=o.ProGeniusProducts&showtrial=1',
        silver: '/index.cfm?go=o.ProGeniusProducts&productCode=PRO_SILVER12',
        gold: '/index.cfm?go=o.ProGeniusProducts&productCode=PRO_GOLD12',
        platinum: '/index.cfm?go=o.ProGeniusProducts&productCode=PRO_PLATINUM12',
      };

      $scope.isEligibleTrialUser = false;

      var getCurrentMemberInfo = function () {
        //get the memberId from cache
        var memInfo = sugCacheFactory.get('memberinfo', {});

        if (Object.keys(memInfo).length == 0) {
          // if nothing is cached, look up live data
          globalService.getMemberInformation()
            .then(function(response) {
              if (SUGUtilities.ajaxResultInvalid(response)) {
                // invalid response, show error
              } else {
                // successfully retrieved memberInfo, update $scope
                var r = SUGUtilities.lowerCaseKeys(response);
                memInfo = r.data.data;
                sugCacheFactory.set('memberinfo',memInfo);

                if( memInfo.memberid == 0 ){
                  $scope.isEligibleTrialUser = true;
                } else {
                  $scope.isEligibleTrialUser = memInfo.iseligiblefortrial;
                }
              }
            });
        } else {
          if( memInfo.memberid == 0 ){
            $scope.isEligibleTrialUser = true;
          } else {
            $scope.isEligibleTrialUser = memInfo.iseligiblefortrial;
          }
        }
      };

      getCurrentMemberInfo();

      // add inactive class dynamically to the plan carousel
      var checkPlanCarouselItem = function () {
        if ($("#plan-carousel .carousel-inner .item:first").hasClass("active")) {
          $("#plan-carousel .left").addClass("inactive");
          $("#plan-carousel .right").removeClass("inactive");
        } else if ($("#plan-carousel .carousel-inner .item:last").hasClass("active")) {
          $("#plan-carousel .right").addClass("inactive");
          $("#plan-carousel .left").removeClass("inactive");
        } else {
          $("#plan-carousel .carousel-control").removeClass("inactive");
        }
      };

      checkPlanCarouselItem();

      $("#plan-carousel").on("slid.bs.carousel", checkPlanCarouselItem);

      // add inactive class dynamically to the features carousel
      $("#features-carousel").carousel({
        interval: false,
        wrap: false
      });
      var checkFeaturesCarouselItem = function () {
        if ($("#features-carousel .carousel-inner .item:first").hasClass("active")) {
          $("#features-carousel .left").addClass("inactive");
          $("#features-carousel .right").removeClass("inactive");
        } else if ($("#features-carousel .carousel-inner .item:last").hasClass("active")) {
          $("#features-carousel .right").addClass("inactive");
          $("#features-carousel .left").removeClass("inactive");
        } else {
          $("#features-carousel .carousel-control").removeClass("inactive");
        }
      };

      checkFeaturesCarouselItem();
      $("#features-carousel").on("slid.bs.carousel", checkFeaturesCarouselItem);

      var pageWindow = angular.element($window);

      // toggle pricing
      $scope.togglePrice = function () {
        // Change this to show and hide divs now
        $scope.useAnnualPricing = !$scope.useAnnualPricing;
        if ($scope.useAnnualPricing) {
          return true;
        } else {
          return false;
        }
      };

      // scroll to contact form with the buttons
      $scope.toggleContactForm = function () {
        setTimeout(function () {
          $("html, body").animate(
            { scrollTop: $(".form-holder").offset().top },
            1200
          );
        }, 450);
      };

      $scope.toggleContactFormBVariation = function () {
        setTimeout(function () {
          $("html, body").animate(
            { scrollTop: $(".form-holder-BVariation").offset().top },
            1200
          );
        }, 450);
      };


      $scope.slideToFeatures = function() {
        setTimeout(function () {
          $("html, body").animate(
            { scrollTop: $("#plan-features").offset().top },
            1200
          );
        }, 450);
      } 

      $scope.slideToFeaturesBVariation = function() {
        setTimeout(function () {
          $("html, body").animate(
            { scrollTop: $(".compare-plans").offset().top },
            1200
          );
        }, 450);
      }

      
      $scope.showSilverFeaturesBVariation = function() {
        var silverfeatures = document.querySelector('.BVariation .silver-mobile-features');
        silverfeatures.classList.toggle('visible-xs-block');
        const viewLink = document.getElementsByClassName("silver-view-link")[0];

        if(silverfeatures.classList.contains('visible-xs-block')){
          if (viewLink) {
            viewLink.textContent = "Hide the full Silver plan features";
          }        
        } else {
          if (viewLink) {
            viewLink.textContent = "View the full Silver plan features";
          }   
        }
       
      }

      $scope.showGoldFeaturesBVariation = function() {
        var goldfeatures = document.querySelector('.BVariation .gold-mobile-features');
        goldfeatures.classList.toggle('visible-xs-block');
        const viewLink = document.getElementsByClassName("gold-view-link")[0];

        if(goldfeatures.classList.contains('visible-xs-block')){
          if (viewLink) {
            viewLink.textContent = "Hide the full Gold plan features";
          }        
        } else {
          if (viewLink) {
            viewLink.textContent = "View the full Gold plan features";
          }   
        }
      }

      $scope.showPlatinumFeaturesBVariation = function() {
        var platinumfeatures = document.querySelector('.BVariation .platinum-mobile-features');
        platinumfeatures.classList.toggle('visible-xs-block');
        const viewLink = document.getElementsByClassName("platinum-view-link")[0];

        if(platinumfeatures.classList.contains('visible-xs-block')){
          if (viewLink) {
            viewLink.textContent = "Hide the full Platinum plan features";
          }        
        } else {
          if (viewLink) {
            viewLink.textContent = "View the full Platinum plan features";
          }   
        }
      }
      $scope.showEnterpriseFeaturesBVariation = function() {
        var enterprisefeatures = document.querySelector('.BVariation .enterprise-mobile-features');
        enterprisefeatures.classList.toggle('visible-xs-block');
        const viewLink = document.getElementsByClassName("enterprise-view-link")[0];

        if(enterprisefeatures.classList.contains('visible-xs-block')){
          if (viewLink) {
            viewLink.textContent = "Hide the full Enterprise plan features";
          }        
        } else {
          if (viewLink) {
            viewLink.textContent = "View the full Enterprise plan features";
          }   
        }
      }

      $scope.showBasicFeaturesBVariation = function() {
        var basicfeatures = document.querySelector('.BVariation .basic-mobile-features');
        basicfeatures.classList.toggle('visible-xs-block');
        const viewLink = document.getElementsByClassName("basic-view-link")[0];

        if(basicfeatures.classList.contains('visible-xs-block')){
          if (viewLink) {
            viewLink.textContent = "Hide the full Basic plan features";
          }        
        } else {
          if (viewLink) {
            viewLink.textContent = "View the full Basic plan features";
          }   
        }

      }


      

      $scope.showSilverFeatures = function() {
        var silverfeatures = document.querySelector('.silver-mobile-features');
        silverfeatures.classList.toggle('visible-xs-block');
      }
      $scope.showGoldFeatures = function() {
        var goldfeatures = document.querySelector('.gold-mobile-features');
        goldfeatures.classList.toggle('visible-xs-block');
      }
      $scope.showPlatinumFeatures = function() {
        var platinumfeatures = document.querySelector('.platinum-mobile-features');
        platinumfeatures.classList.toggle('visible-xs-block');
      }
      $scope.showEnterpriseFeatures = function() {
        var enterprisefeatures = document.querySelector('.enterprise-mobile-features');
        enterprisefeatures.classList.toggle('visible-xs-block');
      }

      // toggle the free, premium, or enterprise slider (premium/enterprise have consolidated)
      $scope.showcategory = function (category) {
        $scope.section = category;
      };
      // toggle to combined premium/enterprise slide
      if (window.location.href.indexOf("enterprise") > -1 && window.location.href.indexOf("enterprisecontact") === -1) {
        $scope.showcategory("premium");
      }
      // toggle to free slide
      if (window.location.href.indexOf("free") > -1) {
        $scope.showcategory("free");
      }
      // scroll to enterprise contact form
      if (window.location.hash === "#/enterprisecontact") {
        $scope.toggleContactForm();
      }

      // slideDown is not included in angular.element / jqLite, so just use jQuery
      jQuery(".promoBanner").slideDown("slow");

      // show variation functionality with Google Optimize
      // use data-ng-if="showVariantA" for conditional markup
      // use data-ng-class="variationClass ? 'container-fluid' : 'container'" for conditional classes
      /*
      $window.showPricingVariation = function(type) {
        if (type === "A") {
          $scope.showDefault = false;
          $scope.showVariantA = true;
          $scope.variationClass = true;
          $scope.showcategory("premium");
        }
        if (type === "default") {
          $scope.showDefault = true;
          $scope.showVariantA = false;
          $scope.variationClass = false;
        }
        $scope.$apply();
      };

      // if Google Optimize doesn't load or is slow, after 3 seconds show default
      $timeout(function() {
        if(!$scope.showVariantA){
          $window.showPricingVariation("default");
        }
      }, 3000);
      */

    },
  ]);
})();
